import React, {  useState } from 'react'
import AdminSettings from './Backgrounds/Settings'
import AiAssistant from './AiAssistant'
import NotificationSettings from './NotificationSettings'
import ShutdownCampaign from './ShutdownCampaign'

function Settings() {
  const hash = window.location?.hash ? window.location.hash.replace('#', '') : null;
  const [activeTab, setActiveTab] = useState(hash === 'shutdown-campaign' ? 'shutdown-campaign' : '')

  return (
    <div className="form-content">
      <div className="setting-form common-form">
        <div className="setting-tabs">
          <ul className="ul-setting-tab">
            <ShutdownCampaign activeTab={activeTab} setActiveTab={setActiveTab} />
            <AdminSettings activeTab={activeTab} setActiveTab={setActiveTab} />
            <AiAssistant activeTab={activeTab} setActiveTab={setActiveTab} />
            <NotificationSettings activeTab={activeTab} setActiveTab={setActiveTab} />
          </ul>
        </div></div>
    </div>
  )
}

export default Settings